import { render, staticRenderFns } from "./LegacyWww.vue?vue&type=template&id=e6141fc0&"
import script from "./LegacyWww.vue?vue&type=script&lang=js&"
export * from "./LegacyWww.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports